import React from 'react';
import { useMutation } from 'react-query';
import { updateBlog } from '../../utils/api';
import { Box, Button, FormControl, FormLabel, Input, Textarea, Stack } from '@chakra-ui/react';
import Swal from 'sweetalert2';

const BlogUpdateForm = ({ blog, onUpdate, onClose }) => {
  const mutation = useMutation((updatedBlogData) => updateBlog(blog._id, updatedBlogData));

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const updatedBlogData = {
      badges: formData.getAll('badges'),
      image: formData.get('image'),
      title: formData.get('title'),
      desc: formData.get('desc'),
      author: formData.get('author'),
    };

    try {
      const updatedData = await mutation.mutateAsync(updatedBlogData);
      onUpdate(updatedData); // Update the blog data in the parent component
      onClose(); // Close the modal after successful update

      // Show the success alert
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Blog updated successfully.',
      });
    } catch (error) {
      console.error('Failed to update blog:', error);
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <Stack spacing="4">
        <FormControl>
          <FormLabel color="white">Badges</FormLabel>
          <Input
            type="text"
            name="badges"
            defaultValue={blog.badges.join(', ')}
            bg="transparent"
            color="white"
            _focus={{ bg: 'transparent' }}
          />
        </FormControl>
        <FormControl>
          <FormLabel color="white">Image</FormLabel>
          <Input
            type="text"
            name="image"
            defaultValue={blog.image}
            bg="transparent"
            color="white"
            _focus={{ bg: 'transparent' }}
          />
        </FormControl>
        <FormControl>
          <FormLabel color="white">Title</FormLabel>
          <Input
            type="text"
            name="title"
            defaultValue={blog.title}
            bg="transparent"
            color="white"
            _focus={{ bg: 'transparent' }}
          />
        </FormControl>
        <FormControl>
          <FormLabel color="white">Description</FormLabel>
          <Textarea
            name="desc"
            defaultValue={blog.desc}
            resize="none"
            bg="transparent"
            color="white"
            _focus={{ bg: 'transparent' }}
          />
        </FormControl>
        <FormControl>
          <FormLabel color="white">Author</FormLabel>
          <Input
            type="text"
            name="author"
            defaultValue={blog.author}
            bg="transparent"
            color="white"
            _focus={{ bg: 'transparent' }}
          />
        </FormControl>
        <Button type="submit" bg="#FFA001" color="white">
          Update Blog
        </Button>
      </Stack>
    </Box>
  );
};

export default BlogUpdateForm;
